import { createContext, useContext, useEffect, useState } from 'react'

type VideoScaleContextType = {
  videoScale: number
}

export const VideoScaleContext = createContext<VideoScaleContextType>({
  videoScale: 1.0,
})

export const useVideoScale = () => {
  const context = useContext(VideoScaleContext)

  return context
}

const BaseWidth = 1440

export const VideoScaleProvider = ({
  children,
  video,
}: {
  children: React.ReactNode
  video: HTMLVideoElement
}) => {
  const [videoScale, setVideoScale] = useState(1.0)

  useEffect(() => {
    const updateScale = () => {
      setVideoScale(Math.max(Math.min(video.offsetWidth / BaseWidth, 1.0), 0.4))
    }

    updateScale()

    const resizeObserver = new ResizeObserver(() => {
      updateScale()
    })

    resizeObserver.observe(video)

    return () => {
      resizeObserver.disconnect()
    }
  }, [video])

  return <VideoScaleContext.Provider value={{ videoScale }}>{children}</VideoScaleContext.Provider>
}
